import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class AlertsService {

  data: Subject<any> = new Subject( );

  
   constructor ( ) {
     this.clearData( );
   }
   
   getData ( ) {
    return this.data;
   }
   
   clearData (  ) {
    this.data.next({
       messageType: '',
       message: '',
       title: ''
    });
    return this.data;
  } 

   setData ( data: any ) {
    this.data.next( data );
    return this.data;
  } 

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/services/alerts.service.ts